import { ObjectId, Timestamp } from ".";

export interface Room {
  _id: ObjectId;
  name: string;
  chatters: Array<ObjectId>;
}

export enum ChatStatus {
  None = 0,
  Waiting,
  Sent,
  Failed,
}

export interface ChatFileBlob {
  name: string;
  ext: string;
  realName: string;
  local: true;
}

export interface ChatFileUrl {
  filename: string;
  thumbnail?: string;
  local: false;
}

export type ChatFilesType = ChatFileType[];
export type ChatFileType = ChatFileUrl | ChatFileBlob;

export interface Chat {
  _id: ObjectId;
  content: string;
  from: ObjectId;
  date: Timestamp;
  files: ChatFilesType;
  status?: ChatStatus;
}

export interface ChatBackend {
  messages: Chat[];
}

export interface ChatContainer {
  [room: string]: Array<Chat> | null;
}

export interface ChatBuilder {
  content: string;
  chat: string;
  id: number;
}

export interface ChatMessage {
  message: Chat;
  chat: ObjectId;
}

export interface ChatMessageId extends ChatMessage {
  id: number;
}
